import {Component, OnInit} from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import {SessionService} from '../../services/session.service';
import {Roles} from '../../enums/enums';
import {Router} from '@angular/router';
import {PopoverController} from '@ionic/angular';
import {HomePopOverComponent} from '../../components/home-pop-over/home-pop-over.component';
import {DataStore} from '@aws-amplify/datastore';
import {Contract, Team, User} from '../../../models';



@Component({
  selector: 'app-home2',
  templateUrl: './home2.page.html',
  styleUrls: ['./home2.page.scss'],
})
export class Home2Page implements OnInit {

  cssClass: string;
    primaryColor: any;
    secondryColor: any;
    fullWhiteLogo: any;
    usersCount: number;
    teamsCount: number;
    clientsCount: number;
    contractsCount: number;

    constructor(
        public sessionService: SessionService,
        public popoverController: PopoverController,
        private navController: NavController,
        private router: Router,
    ) {

    }

    ngOnInit() {
    }

    async ionViewDidEnter() {
        this.applyClassBySelection("zoomIn");
        // const currentUser =  this.sessionService.getCurrentUser();

        // this.usersCount = (await DataStore.query(User)).length;
        // this.teamsCount = (await DataStore.query(Team)).length;
        // this.clientsCount = (await DataStore.query(User, u => u.role("eq", Roles.CLIENT.displayName))).length;
        // // this.contractsCount =  (await DataStore.query(Contract)).filter(c => c.addedBy?.id == currentUser?.id).length;
        // this.contractsCount =  (await DataStore.query(Contract)).length;

        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    applyClassBySelection(effect: string): void {
        this.cssClass = "animated " + effect;
    }

    back() {
      this.navController.back();
    }

}
